import { ReactNode } from 'react';
import { observer } from 'mobx-react';

import TreeItemContainer from '@/common/components/ModalTreeItem/TreeItemContainer/TreeItemContainer';
import TreeItemInput from '@/common/components/ModalTreeItem/TreeItemInput/TreeItemInput';

import styles from './ModalTreeItem.module.css';

export interface TreeItemProps {
  value: string;
  onChange: (value: string) => void;
  isPendingCreation: boolean;
  isSelected: boolean;
  isEdited: boolean;
  save: () => void;
  preview?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

function ModalTreeItem(props: TreeItemProps) {
  const { value, onChange, isPendingCreation, isSelected, isEdited, preview, footer, save, className } = props;

  return (
    <TreeItemContainer isSelected={isSelected} className={className}>
      {preview}

      <div className={styles.content}>
        {isEdited ? (
          <TreeItemInput
            onChange={onChange}
            isPendingCreation={isPendingCreation}
            value={value}
            isSelected={isSelected}
            save={save}
          />
        ) : (
          <span aria-label="Item title">{value}</span>
        )}

        {footer}
      </div>
    </TreeItemContainer>
  );
}

export default observer(ModalTreeItem);
